import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { FactoryService } from "@services/common/factory.service";
import { CommonService } from "@services/common/common.service";
import { ComActionService } from "@services/common/com-action.service";
import { AccountService } from "@services/common/account.service";
import { ComSubService } from "@services/common/com-sub.service";

@Injectable({
    providedIn: 'root'
  })
export class AuthLoginGuard{
    
  constructor(
    private factorySer: FactoryService,
    private comActSer: ComActionService,
    private acctSer: AccountService,
    private comSubSer: ComSubService,
    private comSer: CommonService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree>{
    
    //if there is login statu, user can't able to directly into login page but go to routingCheck
    const isLoginPage = /(shprofile\/login)/.test(state?.url); 
    if (!isLoginPage && this.factorySer.getLoginStatus()) {
      return true;
    } else { 
      /*
        check user login status do diff routing logic by getAccessToken
        for MO:
          1. with WxAuth: reset visitorFlag value to '0', and back to MO base on login routing logic
          2. no WxAuth: can able to enter login flow
      */
      //MO no WxAuth
      const moNoWxAuth = this.factorySer.isMoBZ() && !this.factorySer.getAuthKey();
      console.log('moNoWxAuth..',moNoWxAuth);
      if (isLoginPage && (this.factorySer.toLogin || moNoWxAuth)) {
        return true;
      } else {
        this.comSubSer.refreshLoading(true);
        /*
          getAccessToken for check if there is login statu
          if isLoginPage=true, then don't to routing login page again, otherwise the page should routing to login page if there is no login statu
        */
        const resp = await this.acctSer.getAccessToken(false, true, !isLoginPage);
        if (isLoginPage) {
          // have login status
          if (resp) {
            /* 
              token avalibility:
              valid: to do next check and go to login success routing logic
              invalid(0315BT007): can able to enter login page to do login
            */
            const res = await this.acctSer.validateToken(resp);
            if (res?.code === '0315BT007') {
              return true;
            } else { 
              //check MO with WxAuth
              const moHasWxAuth = this.factorySer.isMoBZ() && this.factorySer.getAuthKey();
              console.log('moHasWxAuth..', moHasWxAuth);
              if (moHasWxAuth) {
                const visitorFlagKey = this.factorySer.getVisitorFlagKey();
                this.comSer.setSingleCookie(visitorFlagKey, '0', this.factorySer.getVisitorFlagTTL());
              }
              this.factorySer.setLoginStatus(true);
              this.comSubSer.refreshLoading(false);
              this.comActSer.routingCheck();
              return false;
            }
          } else { 
            return true;
          }
        } else { 
          this.comSubSer.refreshLoading(false);
          return resp? true: false;
        }
      }
    }
  }

}